import { createAsyncThunk } from '@reduxjs/toolkit';
import { tokenService } from '../../../services/personalAccessTokenService';
import { CreateTokenArgs } from '../../../types/PersonalAccessToken';

// Thunk to list tokens
export const listTokens = createAsyncThunk('tokens/list', async () => {
  return tokenService.listTokens();
});

// Thunk to create a token
export const createToken = createAsyncThunk(
  'tokens/create',
  async (args: CreateTokenArgs) => {
    return tokenService.createToken(args);
  }
);

// Thunk to revoke a token
export const revokeToken = createAsyncThunk(
  'tokens/revoke',
  async (tokenId: string) => {
    return tokenService.revokeToken(tokenId);
  }
);

// Thunk to rotate a token
export const rotateToken = createAsyncThunk(
  'tokens/rotate',
  async (tokenId: string) => {
    return tokenService.rotateToken(tokenId);
  }
);

export const listPermissions = createAsyncThunk(
  'tokens/listPermissions',
  async () => {
    return tokenService.listPermissions();
  }
);
